import * as mutations from './mutations'
import i18n from '../i18n'

export default {
  namespaced: true,
  state: {
    config: {}
  },
  getters: {
    globalResources (state: any) {
      let out = {
        productTranslation: {
          Single: {},
          Plural: {}
        },
        collection: {
          Single: {},
          Plural: {}
        },
        portalType: null
      }
      if (state.config && state.config.general) {
        out = {
          productTranslation: {
            Single:
              state.config.general.type.toLowerCase() === 'music'
                ? i18n.t('tenantBasedConfiguration.MusicPortal.Product.Single')
                : i18n.t('tenantBasedConfiguration.GamePortal.Product.Single'),
            Plural:
            state.config.general.type.toLowerCase() === 'music'
              ? i18n.t('tenantBasedConfiguration.MusicPortal.Product.Plural')
              : i18n.t('tenantBasedConfiguration.GamePortal.Product.Plural')
          },
          collection: {
            Single:
            state.config.general.type.toLowerCase() === 'music'
              ? i18n.t('tenantBasedConfiguration.MusicPortal.Collection.Single')
              : i18n.t('tenantBasedConfiguration.GamePortal.Collection.Single'),
            Plural:
            state.config.general.type.toLowerCase() === 'music'
              ? i18n.t('tenantBasedConfiguration.MusicPortal.Collection.Plural')
              : i18n.t('tenantBasedConfiguration.GamePortal.Collection.Plural')
          },
          portalType: state.config.general.type.toLowerCase()
        }
      }
      return out
    },
    config (state: any) {
      return state.config
    },
    tenantTitle (state: any) {
      let out = ''
      if (state.config && state.config.general && state.config.general.title) {
         out = state.config.general.title
      }
      return out
    },
    cdnAddress (state: any) {
      let out = ''
      if (state.config && state.config.general && state.config.general.cdnAddress) {
         out = state.config.general.cdnAddress
      }
      return out
    },
    featuredCollectionId (state: any) {
      if (!state.config.pages) { return 0 }
      let components = state.config.pages.home.components.filter(
        (c: any) => c.type == 'featuredCollection'
      )

      if (components.length == 0) { return -1 } else { return components[0].configurations.id }
    }
  },
  actions: {
    setConfig (context: any, config: any) {
      context.commit('configurationsReceived', config)

      // This block of code set cdn address for tenants that has no cdn domain
      if (config.general.cdnAddress) {
        context.dispatch('cdn/setBaseAddress', config.general.cdnAddress, { root: true })
      } else {
        context.dispatch('cdn/setBaseAddress', 'http://cdn.stage.sabacell.net/', { root: true })
      }

      config = {
        tenantId: 1,
        general: {
          logoUrl: '/logo-xbuzzi.png',
          title: 'xBuzzi',
          logoWithSubtitleUrl: '/logo-xbuzzi.png',
          cdnAddress: 'http://stageapi.sabacell.net/api/cdn/download/'
        },
        'userManagement': {
          'planProviderCode': '808080',
          'pageCode': ''
        },
        'pages': {
          'home': {
            'components': [
              // { "type": "slider", "configurations": {} },
              // { "type": "simpleCollection", "configurations": { "id": 10 } },
              // { "type": "simpleCollection", "configurations": { "id": 4 } },
              // { "type": "featuredCollection", "configurations": { "id": 12 } },
              // { "type": "simpleCollection", "configurations": { "id": 11 } },
              // { "type": "simpleCollection", "configurations": { "id": 27 } },
              // { "type": "collectionGroup", "configurations": {} }
            ]
          },
          'products': {
            'components': [
              { 'type': 'contactus', 'configurations': {} }
            ]
          },
          'terms': {
            'components': [
              {
                type: 'simpleArticle',
                configurations: {
                  title: 'قوانین و مقررات',
                  text:
                    'هزینه عضویت روزانه 500 تومان <br />لغو عضویت با ارسال off به 9830844  <br />هزینه بسته از شارژ سیم کارت کسر خواهد شد یا اینکه به قبض موبایل شما اضافه می شود <br />پرتال ایکس بازی توسط شرکت صباسل ساخته شده است و در مالکیت این شرکت است. با عضویت در پرتال ایکس بازی اقرار مینمایید که شرایط و ضوابط سرویس را مطالعه کرده اید و با تمامی شرایط آن موافق هستید. صباسل حق تغییر شرایط و ضوابط (شرایط) استفاده از این سرویس از جمله، ولی نه محدود به، حق تعلیق سرویس بدون اعلام قبلی، را برای خود محفوظ میدارد. به شما توصیه میشود که این شرایط را بصورت دوره ای مطالعه نمایید. اگر با بند یا بندهایی از این شرایط یا ضمائم آن موافق نیستید، از این سرویس استفاده نکنید. با عضویت در ایکس بازی، شما موافقت خود را با دریافت پیامها و لینکهای ما در مورد کلیه محتواهای مربوط به بازی اعلام میدارید. برای استفاده از این سرویس، باید یک شماره فعال در همراه اول داشته باشید. عضویت شما بصورت خودکار در این سرویس تمدید میشود. لطفا توجه داشته باشید که هزینه استفاده از اینترنت، بصورت مجزا توسط ارائه دهنده خدمات اینترتی شما دریافت میشود. تا زمانی که سرویس را غیر فعال نکرده باشید، عضویت شما در سرویس بصورت خودکار تمدید میشود.در ایکس بازی عضو شوید و به هر تعداد که مایلید، بازی دانلود کند. کلیک کردن بر روی دکمه عضویت، به منزله موافقت شما با شرایط و ضوابط ذکرشده می باشد.'
                },
                components: []
              },
              {
                type: 'linkCollection',
                configurations: { isContainer: true, direction: 'horizontal' },
                components: [
                  {
                    'type': 'linkCardVertical',
                    'configurations': {
                      'text': 'سبد کاملی از برترین بازی‌های روز را در اختیار داشته باشید',
                      'imageUrl': 'https://image.flaticon.com/icons/svg/263/263421.svg',
                      'linkText': 'بازی‌ها را مرور کنید',
                      'linkUrl': '/',
                      'target': '_self',
                      'classList': 'bg-success',
                      'linkClassList': 'text-success'
                    }
                  },
                  {
                    'type': 'linkCardVertical',
                    'configurations': {
                      'text': 'مانند یک حرفه‌ای با ویژگی‌های بازی‌ها آشنا شوید',
                      'imageUrl': 'https://image.flaticon.com/icons/svg/1054/1054869.svg',
                      'linkText': 'بررسی حرفه‌ای‌ها را بخوانید',
                      'linkUrl': 'http://bazillion.games',
                      'target': '_blank',
                      'classList': 'bg-primary',
                      'linkClassList': 'text-primary'
                    }
                  },
                  {
                    'type': 'linkCardVertical',
                    'configurations': {
                      'text': 'در صورت داشتن هرگونه سوال در ارتباط با قوانین و مقررات',
                      'imageUrl': 'https://image.flaticon.com/icons/svg/651/651016.svg',
                      'linkText': 'با ما تماس بگیرید',
                      'linkUrl': '/ContactUs',
                      'target': '_self',
                      'classList': 'bg-danger',
                      'linkClassList': 'text-danger'
                    }
                  }
                ]
              }
            ]
          },
          contactus: {
            components: [
              {
                type: 'contactus',
                configurations: {
                  title: 'تماس با ما',
                  fullName: 'نام و نام خانوادگی',
                  fullNamePlaceholder: 'سهراب سپهری',
                  emailOrTel: 'پست الکترونیک یا شماره تماس',
                  subject: 'موضوع',
                  subjectPlaceholder: 'قدردانی از بازی‌های جذاب پورتال',
                  message: 'پیام',
                  sendMessage: 'ارسال پیام',
                  fullNameIsRequired:
                    'برای ارسال پیام، باید نام و نام خانوادگی‌تان را وارد کنید',
                  messageIsRequired:
                    'برای ارسال پیام، باید پیام مورد نظرتان را وارد کنید',
                  sendFailureMessage:
                    'ارسال پیام با مشکل روبرو شد، لطفا مجددا تلاش کنید',
                  sendSuccessfull:
                    'از پیامی که برای ما ارسال کردید سپاسگزاریم، در صورت نیاز کارشناسان ما با شما تماس خواهند گرفت'
                }
              },
              {
                type: 'linkCollection',
                configurations: { isContainer: true },
                components: [
                  {
                    'type': 'linkCardHorizontal',
                    'configurations': {
                      'text': 'پست الکترونیک ما',
                      'imageUrl': 'https://image.flaticon.com/icons/svg/214/214316.svg',
                      'linkText': 'games@sabacell.ir',
                      'linkUrl': 'mailto:games@sabacell.ir',
                      'target': '_self',
                      'classList': 'bg-success',
                      'linkClassList': 'text-success'
                    }
                  },
                  {
                    'type': 'linkCardHorizontal',
                    'configurations': {
                      'text': 'ایکس بازی',
                      'imageUrl': 'https://image.flaticon.com/icons/svg/263/263421.svg',
                      'linkText': 'خانه بازی‌ها',
                      'linkUrl': '/',
                      'target': '_self',
                      'classList': 'bg-primary',
                      'linkClassList': 'text-primary'
                    }
                  },
                  {
                    'type': 'linkCardHorizontal',
                    'configurations': {
                      'text': 'شماره تماس با ما',
                      'imageUrl': 'https://image.flaticon.com/icons/svg/273/273501.svg',
                      'linkText': '021-88686941',
                      'linkUrl': 'tel:+982188686941',
                      'target': '_self',
                      'classList': 'bg-danger',
                      'linkClassList': 'text-danger'
                    }
                  }
                ]
              }
            ]
          },
          vasLogin: {
            configurations: {
              footerText:
                'شما در این پورتال، به مجموعه‌ای از بهترین بازی‌ها، با هزینه روزانه پانصد تومان دسترسی خواهید داشت'
            }
          },
          vasUnsub: {
            configurations: {
              unsubText:
                "پس از لغو عضویت خود، امکان استفاده از بازی‌ها این مجموعه را نخواهید داشت. اگر سوالی دارید <a href='/contactUs'>با ما تماس بگیرید</a>",
              unsubInformation:
                'شما می‌توانید با ارسال off به شماره 9830844 عضویت خودتان را در پرتال لغو کنید و یا از فرم روبه‌رو برای لغو عضویت استفاده کنید.',
              successfullUnsubDescription:
                "از اینکه از جمع کاربران پورتال جدا شدید بسیار ناراحتیم، امیدواریم مجددا به جمع ما بپیوندید.<br/> خوشحال می‌شویم اگر دلیل لغو عضویتتان را<a href='/contactUs'> به ما اطلاع دهید </a>، اینکار به ما کمک خواهد کرد تا تجربه بهتری را برای شما و سایر کاربران ایجاد کنیم."
            }
          }
        }
      }

      // context.commit("configurationsReceived", config);
    }
  },
  mutations: {
    configurationsReceived (state: any, config: any) {
      state.config = config
    }
  }
}
